import { requestData, receiveData, receiveError } from '../api/http'
import CloudFlyerAPI                                 from '../api/CloudFlyerAPI'

export const CLOUD_ACCOUNTS_PENDING = 'CLOUD_ACCOUNTS_PENDING'
export const CLOUD_ACCOUNTS_SUCCESS = 'CLOUD_ACCOUNTS_SUCCESS'
export const CLOUD_ACCOUNTS_ERROR   = 'CLOUD_ACCOUNTS_ERROR'
export const CLOUD_ACCOUNT_EXPANDED = 'CLOUD_ACCOUNT_EXPANDED'
export const SELECT_ACCOUNT = 'SELECT_ACCOUNT'
export const SEARCH_ACCOUNT = 'SEARCH_ACCOUNT'
export const SELECT_REGION  = 'SELECT_REGION'
export const SELECT_CREATED = 'SELECT_CREATED'
export const SELECT_USAGE   = 'SELECT_USAGE'
export const SELECT_COST    = 'SELECT_COST'
export const SELECT_COST_RANGE            = 'SELECT_COST_RANGE'
export const SELECT_USAGE_RANGE           = 'SELECT_USAGE_RANGE'
export const DELETE_CLOUD_ACCOUNT_SUCCESS = 'DELETE_CLOUD_ACCOUNT_SUCCESS'
export const DELETE_CLOUD_ACCOUNT_ERROR   = 'DELETE_CLOUD_ACCOUNT_ERROR'
export const EDIT_CLOUD_ACCOUNT           = 'EDIT_CLOUD_ACCOUNT'

export const CLOUD_BUCKETS_PENDING = 'CLOUD_BUCKETS_PENDING'
export const CLOUD_BUCKETS_SUCCESS = 'CLOUD_BUCKETS_SUCCESS'
export const CLOUD_BUCKETS_ERROR   = 'CLOUD_BUCKETS_ERROR'

export const CLOUDS_PENDING = 'CLOUDS_PENDING'
export const CLOUDS_SUCCESS = 'CLOUDS_SUCCESS'
export const CLOUDS_ERROR   = 'CLOUDS_ERROR'

export const selectAccount = selectedAccount => ({
  type: SELECT_ACCOUNT,
  data: selectedAccount
})

export const selectRegion = selectedRegion => ({
  type: SELECT_REGION,
  data: selectedRegion
})

export const searchAccount = search => ({
  type: SEARCH_ACCOUNT,
  data: search
})

export const selectCreated = selectedCreated => ({
  type: SELECT_CREATED,
  data: selectedCreated
})

export const selectCost = selectedCost => ({
  type: SELECT_COST,
  data: selectedCost
})

export const selectUsage = selectedUsage => ({
  type: SELECT_USAGE,
  data: selectedUsage
})

export const selectCostRange = selectedCostRange => ({
  type: SELECT_COST_RANGE,
  data: selectedCostRange
})

export const selectUsageRange = selectedUsageRange => ({
  type: SELECT_USAGE_RANGE,
  data: selectedUsageRange
})

export function expandCloudAccount(data) {
  return {
    type: CLOUD_ACCOUNT_EXPANDED,
    data
  }
}

export function deleteCloudAccount(cloudAccountId) {
  return dispatch => {
    CloudFlyerAPI
    .new_cloud_accounts
    .destroy(cloudAccountId)
    .then(response => {
      dispatch(receiveData(DELETE_CLOUD_ACCOUNT_SUCCESS, cloudAccountId))
    })
    .catch(err => {
      dispatch(receiveError(DELETE_CLOUD_ACCOUNT_ERROR, err))
    })
  }
}

export function editCloudAccount(item) {
  return {
    type: EDIT_CLOUD_ACCOUNT,
    item
  }
}

export const fetchCloudAccounts = ()=> {
  return dispatch => {
    dispatch(requestData(CLOUD_ACCOUNTS_PENDING))
    CloudFlyerAPI
      .new_cloud_accounts
      .all()
      .then((response) => {
        response = response.data
        // console.log("fetch cloud account",response.data);
        if(!response)
          return dispatch(receiveError(CLOUD_ACCOUNTS_ERROR))
        dispatch(receiveData(CLOUD_ACCOUNTS_SUCCESS, (response||{}).data))
      })
      .catch((err) => {
        dispatch(receiveError(CLOUD_ACCOUNTS_ERROR, err))
      })
  }
}

export const new_fetch_clouds = (callback)=> {
  return dispatch => {
    dispatch(requestData(CLOUDS_PENDING))
    CloudFlyerAPI.new_cloud_accounts.clouds()
      .then(res => {
        res = res.data;
        // console.log("cloud account res",res);
        if(!res || !((res||{}).data||{})){
          return dispatch(receiveError(CLOUDS_ERROR, {}))
        }
        dispatch(receiveData(CLOUDS_SUCCESS, ((res||{}).data||{})))
          callback && callback(((res||{}).data||{}))
      })
      .catch(err => dispatch(receiveError(CLOUDS_ERROR, err)))
  }
}

export const new_fetch_buckets = id => {
  return dispatch => {
    dispatch(requestData(CLOUD_BUCKETS_PENDING))
    CloudFlyerAPI
      .new_cloud_accounts
      .buckets(id)
      .then(res => dispatch(receiveData(CLOUD_BUCKETS_SUCCESS, {id:id.cloudAccountId, buckets :((res||{}).data||{})})))
      .catch(err => dispatch(receiveError(CLOUD_BUCKETS_ERROR, err)))
  }
}

export const fetch_clouds = (callback)=> {
  return dispatch => {
    dispatch(requestData(CLOUDS_PENDING))
    CloudFlyerAPI
      .cloud_accounts
      .clouds()
      .then(res => {
        if(!res || !((res||{}).data||{})){
          return dispatch(receiveError(CLOUDS_ERROR, {}))
        }
        dispatch(receiveData(CLOUDS_SUCCESS, ((res||{}).data||{})))
          callback && callback(((res||{}).data||{}))
      })
      .catch(err => dispatch(receiveError(CLOUDS_ERROR, err)))
  }
}

export const fetch_buckets = id => {
  return dispatch => {
    dispatch(requestData(CLOUD_BUCKETS_PENDING))
    CloudFlyerAPI
      .cloud_accounts
      .buckets(id)
      .then(res => dispatch(receiveData(CLOUD_BUCKETS_SUCCESS, {id, buckets :((res||{}).data||{})})))
      .catch(err => dispatch(receiveError(CLOUD_BUCKETS_ERROR, err)))
  }
}
